import axios from "axios";

export function getAxiosErrorMessage(err: unknown): string {
        if (axios.isAxiosError<{ message?: string }>(err)) {
                return (
                        err.response?.data?.message ||
                        (typeof err.response?.data === "string" ? err.response.data : undefined) ||
                        err.message ||
                        ""
                );
        }
        return "";
}

interface ErrorResponse {
  message?: string;
  detail?: { msg?: string; }[];
}

export function getAxiosErrorMessageAuthenticate(err: unknown): string {
  if (axios.isAxiosError<ErrorResponse>(err)) {
    const data = err.response?.data;

    return (
      data?.detail?.[0]?.msg ||
      data?.message ||
      err.message ||
      ""
    );
  }
  return "";
}